export const closedMessage = `This school may no longer be accepting students. Please confirm directly with the school`;
